import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
// eslint-disable-next-line
import { css } from "styled-components/macro";
import { SectionDescription } from "components/misc/Typography.js";
import {
  AtomIcon,
  GemIcon,
  GraduationCapIcon,
  Laptop,
  SnowflakeIcon,
} from "lucide-react";

import VectorDesign from "images/hGreenDot.png";
import VectorDesign1 from "images/Vector1.svg";
import VectorDesign2 from "images/dottedCircle.svg";
import VectorDesign3 from "images/blueDots.svg";

const Container = styled.div`
  ${tw`relative bg-gray-100 overflow-hidden`}
`;

// ---------- Decorative Floating Images ----------
const DecorativeImage = styled.img`
  ${tw`absolute z-0`}
  width: auto;
  height: auto;
  transition: transform 1s ease-in-out;

  &:hover {
    transform: scale(1.1) rotate(8deg);
  }

  &.top-left {
    top: 5%;
    left: 3%;
  }

  &.right-mid {
    top: 40%;
    right: 4%;
  }

  &.right-bottom {
    bottom: 5%;
    right: 2%;
  }

  @media (max-width: 768px) {
    width: 80px;
    opacity: 0.25;
  }
`;

const ThreeColumnContainer = styled.div`
  ${tw`relative z-10 flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center gap-0 max-w-screen-2xl mx-auto py-20 md:py-24`}
`;

const IconImage = styled.img`
  ${tw`w-30 sm:w-32 mt-3 mb-2`}
`;

const Heading = styled.h1`
  ${tw`w-full mb-0 px-6 font-bold text-center md:text-center text-3xl md:text-3xl text-[#01325b]`}
`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 max-w-sm`}
`;

const Card = styled.div`
  ${tw`flex flex-col sm:flex-row items-center sm:items-start text-left md:text-center 
    lg:text-center sm:text-left lg:w-1/3 h-full px-0 lg:px-6 py-10`}

  .points {
    ${tw`px-10 text-left md:text-center lg:text-center mb-5 lg:px-0 lg:text-left first:lg:mb-20 `}
  }

  .title {
    ${tw`mt-4 tracking-wide font-semibold text-2xl leading-none block`}
  }

  .description {
    ${tw`mt-1 sm:mt-4 font-normal text-black leading-6`}
  }
`;

export default ({
  heading = "Why You Should Study From CA Vijender Aggarwal Sir?",
}) => {
  return (
    <Container>
      {/* Floating Decorative Images */}
      <DecorativeImage
        src={VectorDesign}
        alt="decoration"
        className="top-left"
      />
      <DecorativeImage
        src={VectorDesign2}
        alt="decoration"
        className="right-mid"
      />
      <DecorativeImage
        src={VectorDesign3}
        alt="decoration"
        className="right-bottom"
        style={{ color: "green" }}
        tw="text-[#000]"
      />

      <ThreeColumnContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Heading>{heading}</Heading>
          <IconImage src={VectorDesign1} alt="vector icon" />
        </div>

        <Card>
          <div>
            <div className="points" style={{ textAlign: "justify" }}>
              <div tw="bg-[#3f6c68] rounded-full p-3 shadow flex items-center justify-center w-16 h-16">
                <GraduationCapIcon tw="w-16 h-16 text-white" />
              </div>
              <h3 className="title">
                Conceptual Clarity’ – Our Top-Most Priority
              </h3>
              <p className="description">
                Taxation’ Is A Very Dynamic Subject Where ICAI Comes Up With
                New-Framing Of Questions Every Attempt. We Prepare Our Students
                By Focusing On Conceptual Clarity & Practical Application Of
                Each & Every Topic So That They Can Tackle Any Type Of Question
                From Any Topic
              </p>
            </div>

            <div className="points" style={{ textAlign: "justify" }}>
              <div tw="bg-[#3f6c68] rounded-full p-3 shadow flex items-center justify-center w-16 h-16">
                <Laptop tw="w-16 h-16 text-white" />
              </div>
              <h3 className="title">‘Interactive Classes’ - Our Passion:</h3>
              <p className="description">
                Use Of Power-Point Presentations (PPTs), Videos & Mnemonics To
                Simplify The Interpretation & Learning Of Law For The Students.
                Cumulative Revision Of Concepts During The Course Of Classes For
                Better Retention Of The Students.
              </p>
            </div>

            <div className="points" style={{ textAlign: "justify" }} tw="mt-30">
              <div tw="bg-[#3f6c68] rounded-full p-3 shadow flex items-center justify-center w-16 h-16">
                <AtomIcon tw="w-16 h-16 text-white" />
              </div>
              <h3 className="title">
                ‘Additional Support Beyond Classes’ - Our Commitment:
              </h3>
              <p className="description">
                Constant Support On YouTube Channel Through Uploading Of
                Revisionary Marathons, Amendment Classes, Latest Updates,
                Motivational Sessions, etc. In Addition, Sharing Flowcharts,
                Summaries, Latest Q&A, New Issues In Taxation For Development Of
                Students Through Telegram Channel.
              </p>
            </div>
          </div>
        </Card>

        <Card>
          <div>
            <div className="points" style={{ textAlign: "justify" }} tw="mt-0 ">
              <div tw="bg-[#3f6c68] rounded-full p-3 shadow flex items-center justify-center w-16 h-16">
                <GemIcon tw="w-16 h-16 text-white" />
              </div>
              <h3 className="title">‘Regular Assessment’ - Our Mission:</h3>
              <p className="description">
                Providing Topic-Wise Tests To The Students After Completion Of
                Every Topic So That Students Can Self-Assess Their Understanding
                Of The Law And The Quality Of Answers Written By Them. Regular
                Assessment Helps Students In Improving Their Exam-Preparedness.
              </p>
            </div>

            <div className="points" style={{ textAlign: "justify" }}>
              <div tw="bg-[#3f6c68] rounded-full p-3 shadow flex items-center justify-center w-16 h-16">
                <SnowflakeIcon tw="w-16 h-16 text-white" />
              </div>
              <h3 className="title">‘Problem-Solving’ – Our USP:</h3>
              <p className="description">
                Discussion Of Maximum Numerical Problems During The Classes
                Itself In Order To Ensure No/Minimal Homework. Further, We Give
                Equal Focus To Subjective Q&A As Well Objective Q&A (MCQs).
                Parallelly, We Give Special Emphasis On Understanding As To How
                To Write Answers Of Subjective Questions So That Students Can
                Master The Art Of Writing Answers.
              </p>
            </div>

            <div
              className="points"
              style={{ textAlign: "justify" }}
              tw="mt-0 lg:mt-24"
            >
              <div tw="bg-[#3f6c68] rounded-full p-3 shadow flex items-center justify-center w-16 h-16">
                <GraduationCapIcon tw="w-16 h-16 text-white" />
              </div>
              <h3 className="title">‘Ranker’s Way’ - Our Way:</h3>
              <p className="description">
                Being An All India Topper At Both CA-Intermediate & CA-Final
                Levels Along With Best Paper Award For Taxation At Both
                CA-Intermediate & CA-Final Levels, CA Vijender Aggarwal Sir
                Constantly Shares Tips & Tricks During The Course Of Classes So
                That Students Can Equip Themselves Better In Order To Score An
                ‘All India Rank’.
              </p>
            </div>
          </div>
        </Card>
      </ThreeColumnContainer>
    </Container>
  );
};
